let shareLink = document.getElementsByClassName('share-link');
let shareButton = document.getElementsByClassName('share-button');

for (let i = 0; i < shareLink.length; i++) {
    let shareSpan = shareButton[i].getElementsByTagName('span');

    shareLink[i].addEventListener('click', function() {
        shareButton[i].classList.toggle('open');
    })

    shareButton[i].addEventListener("click", function() {
        copyText(window.location.href);
        console.log(window.location.href);
        shareSpan[0].textContent = 'URL Copied!';

        setTimeout(function(){ 
            shareSpan[0].textContent = 'Copy Link';
            shareButton[i].classList.remove('open');
        }, 3000);
    });
}

function copyText(element) {
    console.log(element);
    var myTemporaryInputElement = document.createElement("input");
    myTemporaryInputElement.type = "text";
    myTemporaryInputElement.value = element;
    document.body.appendChild(myTemporaryInputElement);
    myTemporaryInputElement.select();
    document.execCommand("Copy");
    document.body.removeChild(myTemporaryInputElement);
  }
